var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-wrapper"}},[_c('Loader'),_c('Header'),_c('Menu'),_c('div',{staticClass:"content-body rightside-event"},[_c('div',{staticClass:"container"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }